/** Shared formatting helpers. Indian locale throughout. */

const inr = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

const inrPrecise = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** ₹1,299 — for prices shown in marketing copy. */
export const formatCurrency = (value) => inr.format(Number(value) || 0);

/** ₹588.82 — for invoice lines where paise matter. */
export const formatCurrencyPrecise = (value) => inrPrecise.format(Number(value) || 0);

/** 1,29,999 — Indian digit grouping, no symbol. */
export const formatNumber = (value) => new Intl.NumberFormat('en-IN').format(Number(value) || 0);

/** "15 Aug 2026" from an ISO date string. */
export function formatDate(iso) {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

/** "Sat, 15 Aug" — compact form for cards. */
export function formatDateShort(iso) {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
}

/** "1 Aug 2026, 10:15 am" — for records and receipts. */
export function formatDateTime(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value ?? '');
  return date.toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' });
}

/** GST is 18% on skill-development services. Rounded to paise. */
export const GST_RATE = 0.18;

export function priceBreakdown(baseAmount, discount = 0) {
  const net = Math.max(0, Number(baseAmount || 0) - Number(discount || 0));
  const gst = Math.round(net * GST_RATE * 100) / 100;
  const total = Math.round((net + gst) * 100) / 100;
  return { net, gst, total };
}

export const discountPercent = (original, price) => {
  const from = Number(original) || 0;
  const to = Number(price) || 0;
  if (from <= 0 || to >= from) return 0;
  return Math.round(((from - to) / from) * 100);
};

/** "MM:SS" from a second count. */
export function formatClock(totalSeconds) {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const m = String(Math.floor(seconds / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return `${m}:${s}`;
}

/** Turn "06:00 PM IST" + "2026-08-15" into a Date. Returns null if unparseable. */
export function parseWorkshopStart(dateStr, timeStr) {
  if (!dateStr) return null;
  const match = /(\d{1,2}):(\d{2})\s*(AM|PM)?/i.exec(timeStr || '');
  let hours = 18;
  let minutes = 0;
  if (match) {
    hours = parseInt(match[1], 10);
    minutes = parseInt(match[2], 10);
    const meridiem = (match[3] || '').toUpperCase();
    if (meridiem === 'PM' && hours < 12) hours += 12;
    if (meridiem === 'AM' && hours === 12) hours = 0;
  }
  const date = new Date(`${dateStr}T00:00:00+05:30`);
  if (Number.isNaN(date.getTime())) return null;
  date.setHours(date.getHours() + hours, date.getMinutes() + minutes, 0, 0);
  return date;
}
